// extracted by mini-css-extract-plugin
export default {"responsiveMap":"Map_responsiveMap__e-Gpt"};